import { createMessages } from '@play-co/replicant';
import { stateSchema } from '../../State';

// Helper for defining module messages
export default createMessages(stateSchema, {
  // Uncommenting this breaks the Replicant config because reasons
  // ruleset: { abTests: ab.dynamicAB },
});
